module.exports = __webpack_public_path__ + "assets/img/pedigree-chart-bffdb70a.png";